<template>
	<div class="box">
		<div class="row">
			<div class="col-12">
	            <DateRangeV2
	                :start.sync="start_date"
	                :end.sync="end_date"
	                :dateSelect="true"
	                :periodToShow="['personalise','jour','mois','mois_dernier']"
					@submit="loadLots"
	            />
			</div>
			<div class="col-12">
				<CustomTable
		            id_table="last_congelation"
		            ref="table"
		            :items="lots"
		            :busy.sync="table_busy"
		            primaryKey="semencelot_id"
		            :hide_if_empty="true"
		            :hrefsRoutes="config_table_hrefs"
		            :externSlotColumns="['proprietaires']"
		        >
					<template v-slot:[`custom-slot-cell(proprietaires)`]="{ data }">
						<router-link v-for="tiers in data.proprietaires" :key="tiers.id" :to="{ name: 'tiersFiche', params: { tiers_id: tiers.id }}">
		                    {{ tiers.tiers_rs }}<br>
		                </router-link>
					</template>
		    	</CustomTable>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"

	export default {
		name: 'LastCongelation',
		mixins: [Congelation],
		data () {
			return {
				table_busy: false,
				lots: [],
				start_date: new Date(new Date().setDate(new Date().getDate() - 30)),
				end_date: new Date(),
				config_table_hrefs: {
					'stallion.horse_nom': {
						routeUniqueName: 'StallionFiche',
						routeName: 'horseFiche',
						params: {
							horse_id: 'stallion.horse_id'
						}
					},
					'centre.tiers_rs': {
						routeUniqueName: 'centreFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'centre.tiers_id'
						}
					}
				}
			}
		},

		methods: {
			async loadLots() {
				this.table_busy = true
				this.lots = await this.getLastCongelation(this.start_date, this.end_date)
				this.table_busy = false
			},
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
			DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2')
		}
	}

</script>